angular.module('pulseApp').config(function($stateProvider, $urlRouterProvider) {
    
    $stateProvider.state('review', {
        url: '/review/:id',
        controller: 'ReviewCtrl as vm',
        templateUrl: 'app/view/review/review.html',
    });    

}).controller('ReviewCtrl', function ($scope, $state, $stateParams, $firebaseArray) {
 
    var vm = this;
vm.id = $stateParams.id;
    var ref = firebase.database().ref('Providers').child(vm.id).child('Reviews');
    // download the data into a local object
    vm.data = $firebaseArray(ref);
    vm.stars = 0;
    vm.review = {
        Safe: '',
        Helpful: ''
    };

    vm.addReview = function() {
        var today = moment().format('MMMM YYYY');

        if(vm.review.Name === undefined){
            vm.review.Name = 'Anonymous';
        }
        vm.review.ReviewHelpCount = 0;
        vm.review.ReviewDate = today;
        vm.review.Stars = vm.stars;
        if(vm.review.Helpful === undefined)
{
    vm.review.Helpful = '';
}      
if(vm.review.Safe === undefined){
    vm.review.Safe = '';
}
  vm.data.$add(vm.review).then(function(ref) {
            $state.go('provider', { id: vm.id });
          });
      };

    var destroy = $scope.$on("$destroy", function () {
        //Cleanup anything that would persist beyond destruction, including $on/$watch
        destroy();
    });
});